{
    "Profile_Drivers_CancellationReason.cancellation": "Cancellation",
    "Profile_Drivers_CancellationReason.cancellationDetails": "Cancellation Details",
    "Profile_Drivers_CancellationReason.dateOfCancellation": "Date of Cancellation",
    "Profile_Drivers_CancellationReason.cancellationReason": "Cancellation Reason"
}
